import React, { ReactNode } from 'react';
import styled from 'styled-components';
import Typography from 'design-component/Typography';

interface DialogTitleProps {
  children: string | ReactNode;
  style?: React.CSSProperties;
}

const DialogTitle: React.FC<DialogTitleProps> = ({ children, style }) => {
  return (
    <Title weight={700} height="20px" style={style}>
      {children}
    </Title>
  );
};

export default DialogTitle;

const Title = styled(Typography)`
  margin: 0;
  padding: 30px 20px;
  box-sizing: border-box;

  // border-bottom: 1px solid #e0e0e0;
`;
